import { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { PagedDialog } from '@components';
import {
	AdditionalDetails,
	ReferenceNumbers,
	DriverInfo,
	ContactDetails,
	UpdateETA,
	Location,
	Cargo,
	Modifiers
} from './Pages/index';
import { useGetShipperETAReasons, useGetAdminETAReasons } from '@api';
import { TShiperETAReason, TEditShipmentErrors } from '@types';
import { IsAdmin, DomainContext } from '@state';
import { useRecoilValue } from 'recoil';

type TProps = {
	errors: TEditShipmentErrors | null;
	setErrors: Dispatch<SetStateAction<TEditShipmentErrors | null>>;
	refetch?: () => void;
}

export const Pages = (props: TProps) => {
	const { errors, setErrors, refetch } = props;
	const isAdmin = useRecoilValue(IsAdmin);
	const domainContext = useRecoilValue(DomainContext);
	const isAdminOnAllLoads = isAdmin && domainContext !== 'shipper';

	const { callGetETAReasons } = useGetShipperETAReasons();
	const { callGetAdminETAReasons } = useGetAdminETAReasons();
	const [etaReasons, setETAReasons] = useState<TShiperETAReason[]>([]);

	useEffect(() => {
		const fetcher: Promise<any> = isAdminOnAllLoads
			? callGetAdminETAReasons().then((res: any) => res?.data?.data ?? [])
			: callGetETAReasons().then((res: any) => res?.data?.data ?? []);

		fetcher.then((reasons: TShiperETAReason[]) => {
			setETAReasons(reasons.filter((r) => r.key !== 'Admin Other' && r.key !== 'Shipper Other'));
		}).catch((err: any) => {
			if (err?.cause) console.error(err);
		});
	}, [isAdminOnAllLoads]);

	return (
		<PagedDialog.Pages>
			<PagedDialog.Page id={0}>
				<UpdateETA reasons={etaReasons} />
			</PagedDialog.Page>
			<PagedDialog.Page id={1}>
				<Cargo refetch={refetch} />
			</PagedDialog.Page>
			<PagedDialog.Page id={2}>
				<Location />
			</PagedDialog.Page>
			<PagedDialog.Page id={3}>
				<ContactDetails errors={errors} setErrors={setErrors} />
			</PagedDialog.Page>
			<PagedDialog.Page id={4}>
				<DriverInfo />
			</PagedDialog.Page>
			<PagedDialog.Page id={5}>
				<ReferenceNumbers errors={errors} setErrors={setErrors} />
			</PagedDialog.Page>
			<PagedDialog.Page id={6}>
				<AdditionalDetails />
			</PagedDialog.Page>
			<PagedDialog.Page id={7}>
				<Modifiers refetch={refetch} />
			</PagedDialog.Page>
		</PagedDialog.Pages>
	);
}
Pages.displayName = 'Pages';
